import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export type Theme = 'light' | 'dark'

interface ThemeState {
  theme: Theme
  toggleTheme: () => void
}

const getInitialTheme = () => {
  const theme = typeof window !== 'undefined' ? localStorage?.getItem('infura-theme') : null
  return theme ? JSON.parse(theme).state : 'dark'
}

const useThemeStore = create<ThemeState>()(
  persist(
    (set, get) => ({
      theme: getInitialTheme(),
      toggleTheme: () => {
        const currentTheme = get().theme
        const nextTheme = currentTheme === 'dark' ? 'light' : 'dark'
        set({ theme: nextTheme })
      }
    }),
    {
      name: 'infura-theme'
    }
  )
)

export const useTheme = () => useThemeStore(state => state.theme)
export const useToggleTheme = () => useThemeStore(state => state.toggleTheme)
